import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArMR: CultureInfo = {
  name: 'ar-MR',
  displayName: 'العربية (موريتانيا)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-MR',
  parent: CultureInfoAr
};
